import React, { useCallback } from "react";
import { easeOut } from "ol/easing";
import Icon from "@avinet/adaptive-ui-core/ui/Icon";
import { useMapContext } from "../map/MapProvider";
import "./Zoom.scss";
/**
 * Add the Zoom control to the map (zoom in/zoom out buttons).
 */
export default function Zoom({ zoomInTitle, zoomOutTitle, zoomInIcon = "add", zoomOutIcon = "subtract", }) {
    const { view } = useMapContext();
    const handleZoomIn = useCallback(() => {
        var _a;
        return view.animate({
            zoom: Math.min(view.getMaxZoom(), ((_a = view.getZoom()) !== null && _a !== void 0 ? _a : view.getMinZoom()) + 1),
            duration: 250,
            easing: easeOut,
        });
    }, [view]);
    const handleZoomOut = useCallback(() => {
        var _a;
        return view.animate({
            zoom: Math.max(view.getMinZoom(), ((_a = view.getZoom()) !== null && _a !== void 0 ? _a : view.getMinZoom()) - 1),
            duration: 250,
            easing: easeOut,
        });
    }, [view]);
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: "btn map icon zoom-in", title: zoomInTitle, onClick: handleZoomIn },
            React.createElement(Icon, { name: zoomInIcon })),
        React.createElement("button", { type: "button", className: "btn map icon zoom-out", title: zoomOutTitle, onClick: handleZoomOut },
            React.createElement(Icon, { name: zoomOutIcon }))));
}
